import React from 'react';

import FormSelectField, { toOptions } from './FormSelectField';

interface ISelectFieldProps {
  label?: string;
  options: string[] | { value: string; label: string }[];
  value?: string;
  onChange: (value: string) => void;
  id?: string;
  innerRef?: React.RefObject<HTMLInputElement> | ((el: HTMLDivElement) => void);
  styles?: React.CSSProperties | Record<string, React.CSSProperties>;
  error?: string;
  required?: boolean;
}

const SelectField = ({ options, value, styles, ...props }: ISelectFieldProps) => (
  <FormSelectField
    {...props}
    defaultValue={value}
    // Before the FormSelectField consolidation, SelectField always stretched to fill its
    // container unless the caller set an explicit width via styles. fullWidth would clobber
    // an explicit width (it spreads after styles), so only apply it when none is given.
    fullWidth={!(styles && 'width' in styles)}
    options={typeof options[0] === 'string' ? toOptions(options as string[]) : options}
    styles={styles}
  />
);

export default SelectField;
